import {getCheckoutUrl} from 'Common/api';
import {getShowUpgrade, useUserContext} from 'Contexts/UserContext/UserContext';
import RenditionDroplet from 'Icons/RenditionDroplet';
import SlashIcon from 'Icons/Slash';
import {logEvent} from '@pmf/analytics';
import React from 'react';
import {Link} from 'react-router-dom';
import {twMerge} from 'tailwind-merge';

interface Props {
    dark?: boolean;
}

export const NavBar = ({dark}: Props) => {
    const {user, signOut, userId, sessionId, deviceId, availableCredits} = useUserContext();

    return (
        <nav
            className={twMerge(
                'flex h-16 w-full items-center justify-between border-b border-[#eee] p-5',
                dark && 'bg-neutral-850 border-neutral-700'
            )}
        >
            <div
                className={twMerge(
                    'flex flex-row items-center justify-between gap-1.5 self-start',
                    dark && 'text-white'
                )}
            >
                <Link to="/">
                    <RenditionDroplet />
                </Link>
                {user?.googleUser && (
                    <>
                        <SlashIcon dark={dark} />
                        <h1 className="font-['Inter'] text-xs">{user?.googleUser.name}</h1>
                    </>
                )}
            </div>
            <div
                className={twMerge(
                    'flex h-full flex-row items-center justify-between gap-4 self-end',
                    dark && 'text-white'
                )}
            >
                {user && getShowUpgrade(user, availableCredits) && (
                    <a
                        href={getCheckoutUrl(userId)}
                        target="_blank"
                        rel="noreferrer"
                        onClick={() => {
                            logEvent('Checkout Start', userId, {data: {sessionId, deviceId}, user});
                        }}
                        className="mr-4 border-b border-transparent bg-gradient-to-r from-[#FF9900] via-[#FF4D4D] to-[#FF7670] bg-clip-text text-base font-bold text-black text-transparent hover:border-b hover:border-solid hover:border-b-[#FF9900]"
                    >
                        Upgrade Now
                    </a>
                )}
                {user && (
                    <p className="text-xs font-bold text-black px-4 py-1 border-black border-r border-solid">
                        Available Credits: {availableCredits}
                    </p>
                )}
                {user && (
                    <button
                        onClick={signOut}
                        className="appearance-none border-none font-['Inter'] text-xs hover:underline"
                    >
                        Sign Out
                    </button>
                )}
            </div>
        </nav>
    );
};
